import { useState } from "react";

export const useTableFilterDraft = <T>(
  filters: T[],
  isMobile: boolean,
  isOpen: boolean,
  onChange: (next: T[]) => void
) => {
  const [draft, setDraft] = useState<{ source: string; filters: T[] } | null>(null);
  const identity = JSON.stringify(filters);

  return {
    filters: isOpen && draft?.source === identity ? draft.filters : filters,
    change: (next: T[]) => {
      if (isMobile) {
        setDraft({ source: identity, filters: next });
      } else {
        onChange(next);
      }
    },
    discard: () => setDraft(null),
  };
};
